export default "__VITE_ASSET__C3OhLXGX__"